import axiosInstance from '../axiosInstance';

export const workspaceService = {
  createWorkspace: async (workspaceName, adminEmail) => {
    try {
      const response = await axiosInstance.post('/api/admin/workspaces', {
        workspaceName,
        adminEmail,
      });
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  listWorkspaces: async () => {
    try {
      const response = await axiosInstance.get('/api/admin/workspaces');
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  getAdminDashboard: async (companyId) => {
    try {
      const response = await axiosInstance.get('/api/admin/dashboard', {
        params: companyId ? { companyId } : undefined,
      });
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default workspaceService;
